import React from 'react';
import './entities-view.css';
import '../../styles/page-common.css';
import '../../styles/list-glass.css';
import { Redirect } from "react-router-dom";
import SpinnerView from '../../components/spinner/spinner-view';
import DownloadLink from "react-download-link";
import urls from '../../network/urls';
import EntityComponent from '../../components/entityComponent';
import { format } from '../../helpers/invoiceNumber';

const CLIENT_COLS = '1.9fr 1fr 1fr 0.6fr';

class EntityView extends React.Component {

  state = {
    modal: false,
    newEntity: {},
    showAdd: false,
    rankType: 'all',
    search: ''
  }

  componentDidMount() {
    if (this.props.selectedCompanyId) {
      this.props.dispatchGetEntities();
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.selectedCompanyId && this.props.selectedCompanyId !== prevProps.selectedCompanyId) {
      this.props.dispatchGetEntities();
    }
  }

  setRank = (rank) => {
    this.setState({ rankType: rank });
  }

  handleSearch = (value) => {
    this.setState({ search: value });
  }

  updateshowAdd = (showAdd) => {
    this.setState({ showAdd });
    if (!showAdd) {
      this.props.dispatchGetEntities();
    }
  }

  getDataFromURL = (url, user) => new Promise((resolve, reject) => {
    setTimeout(() => {
      let req = {
        headers: { username: user.username, token: user.token, AUTHORIZATION: user.token },
        method: 'GET'
      }
      fetch(url, req)
        .then(response => response.blob())
        .then(data => { resolve(data) });
    });
  }, 2000);

  exportToCsv = (e) => {
    e.preventDefault();
    if (!this.props.entities || this.props.entities.length === 0) return;
    let headers = Object.keys(this.props.entities[0]);
    headers = headers.filter(i => i != 'entityTemplateId' && i != 'userId' && i != 'companyId' && i != 'statementTemplateId');
    const downloadFile = ({ data, fileName, fileType }) => {
      const blob = new Blob([data], { type: fileType });
      const a = document.createElement('a');
      a.download = fileName;
      a.href = window.URL.createObjectURL(blob);
      a.dispatchEvent(new MouseEvent('click', { view: window, bubbles: true, cancelable: true }));
      a.remove();
    };
    downloadFile({
      data: [headers.join(';'), ...this.props.entities.map(t => headers.map(h => t[h]).join(';'))].join('\n'),
      fileName: 'Clients.csv',
      fileType: 'text/csv',
    });
  }

  render() {
    if (this.props.user && !this.props.user._id) {
      return <Redirect to='/' />
    }

    const templates = this.props.templates || [];
    const templateName = (id) => {
      const t = templates.find(t => t._id === id);
      return t ? t.entityTemplateName : '';
    };

    let totalU = 0;
    let rows = [];
    if (this.props.entities && this.props.entities.length > 0) {
      rows = this.props.entities.map(p => {
        const outstanding = parseFloat(p.outstanding) || 0;
        totalU += outstanding;
        return {
          id: p._id,
          name: (p.name + ' ' + (p.surname ?? '')).trim(),
          email: p.email || p.emailAddress || '',
          entityTemplateId: p.entityTemplateId,
          type: templateName(p.entityTemplateId),
          outstanding,
        };
      });
    }

    const filtered = rows
      .filter(i => this.state.rankType === 'all' ? true : i.entityTemplateId === this.state.rankType)
      .filter(i => {
        if (this.state.search === '') return true;
        const q = this.state.search.toLowerCase();
        return (i.name || '').toLowerCase().includes(q) || (i.type || '').toLowerCase().includes(q);
      })
      .sort((a, b) => b.outstanding - a.outstanding);

    const groups = { owing: [], settled: [] };
    filtered.forEach(i => (i.outstanding > 0 ? groups.owing : groups.settled).push(i));
    const groupOrder = [
      { key: 'owing', label: 'Outstanding', cls: 'overdue' },
      { key: 'settled', label: 'Settled', cls: 'paid' },
    ];

    const withBalance = rows.filter(i => i.outstanding > 0).length;
    const pct = rows.length > 0 ? Math.round(((rows.length - withBalance) / rows.length) * 100) : 0;
    const DONUT_CIRC = 263.89;
    const donutOffset = DONUT_CIRC * (1 - pct / 100);

    const initials = (nm) => (nm || '?').split(' ').filter(Boolean).slice(0, 2).map(w => w[0]).join('').toUpperCase();
    const avColor = (nm) => { let h = 0; for (let c = 0; c < (nm || '').length; c++) h = (h * 31 + nm.charCodeAt(c)) % 6; return h; };

    const openEntity = (id) => {
      this.props.dispatchGetEntity(id, (error) => { if (!error) this.updateshowAdd(true); });
    };

    return (
      <div
        className="content-wrapper p-2 accent-clients"
        style={{ ['--list-accent']: '#4F46E5', ['--list-accent-dark']: '#3730A3' }}
      >
        <SpinnerView showSpinner={this.props.loading} />

        {this.state.showAdd && (
          <div style={{ margin: '16px 6px' }}>
            <div style={{ background: '#fff', borderRadius: 12, boxShadow: '0 2px 8px rgba(0,0,0,0.08)', overflow: 'hidden' }}>
              <EntityComponent updateshowAdd={this.updateshowAdd} />
            </div>
          </div>
        )}

        {/* Hero band */}
        {!this.state.showAdd && (
          <div className="gl-hero">
            <div className="gl-hero-row">
              <div>
                <div className="gl-hero-title">Clients</div>
                <div className="gl-hero-sub">{rows.length} client{rows.length === 1 ? '' : 's'} · R {format(totalU)} outstanding</div>
              </div>
              <div className="gl-hero-actions">
                <button className="gl-hero-btn" onClick={this.exportToCsv}>
                  <i className="fas fa-arrow-down"></i> Export CSV
                </button>
                <DownloadLink
                  label={<><i className="fas fa-file-excel"></i> Export Excel</>}
                  className="gl-hero-btn"
                  style={{ textDecoration: 'none' }}
                  filename={"client_export.xlsx"}
                  exportFile={() => {
                    let url = urls.getEntities(this.props.selectedCompanyId) + '/export';
                    return Promise.resolve(this.getDataFromURL(url, this.props.user));
                  }}
                />
                <button
                  className="gl-hero-btn solid"
                  onClick={() => { this.props.dispatchSelectEntity(undefined); this.updateshowAdd(true); }}
                >
                  <i className="fas fa-plus"></i> New client
                </button>
              </div>
            </div>
          </div>
        )}

        {/* Summary band */}
        {!this.state.showAdd && (
          <div className="gl-summary">
            <div className="gl-sum-main">
              <div className="gl-sm-eyebrow">Total outstanding</div>
              <div className="gl-sm-amount-row">
                <div><span className="gl-sm-cur">R </span><span className="gl-sm-num">{format(totalU)}</span></div>
              </div>
              <div className="gl-sm-legend">
                <div className="gl-sm-leg-item">
                  <div className="gl-sm-leg-dot" style={{ background: '#fff' }}></div>
                  <div><div className="gl-sm-leg-lbl">Clients</div><div className="gl-sm-leg-val">{rows.length}</div></div>
                </div>
                <div className="gl-sm-leg-item">
                  <div className="gl-sm-leg-dot" style={{ background: 'rgba(255,255,255,0.45)' }}></div>
                  <div><div className="gl-sm-leg-lbl">With balance</div><div className="gl-sm-leg-val">{withBalance}</div></div>
                </div>
              </div>
              <svg className="gl-sm-donut" width="104" height="104" viewBox="0 0 110 110">
                <circle cx="55" cy="55" r="42" fill="none" stroke="rgba(255,255,255,0.18)" strokeWidth="10" />
                <circle cx="55" cy="55" r="42" fill="none" stroke="#fff" strokeWidth="10"
                  strokeDasharray={DONUT_CIRC} strokeDashoffset={donutOffset} strokeLinecap="round" transform="rotate(-90 55 55)" />
                <text x="55" y="58" textAnchor="middle" fontFamily="GothamRounded, sans-serif" fontWeight="800" fontSize="20" fill="#fff" dominantBaseline="middle">{pct}%</text>
              </svg>
            </div>

            <div className="gl-sum-side">
              <div className="gl-ss-eyebrow">Total clients</div>
              <div className="gl-ss-amount">{rows.length}</div>
              <div className="gl-ss-meta">{templates.length} client type{templates.length === 1 ? '' : 's'}</div>
              <span className="gl-ss-pill ok"><i className="fas fa-users" style={{ fontSize: 8 }}></i> Active</span>
            </div>

            <div className="gl-sum-side">
              <div className="gl-ss-eyebrow">With balance</div>
              <div className="gl-ss-amount">{withBalance}</div>
              <div className="gl-ss-meta">client{withBalance === 1 ? '' : 's'} owing</div>
              {withBalance > 0
                ? <span className="gl-ss-pill danger"><i className="fas fa-circle" style={{ fontSize: 5 }}></i> Needs follow-up</span>
                : <span className="gl-ss-pill ok"><i className="fas fa-circle" style={{ fontSize: 5 }}></i> All settled</span>}
            </div>
          </div>
        )}

        {/* Filter bar */}
        {!this.state.showAdd && (
          <div className="gl-filter">
            <div className="gl-seg">
              <button className={`gl-seg-btn ${this.state.rankType === 'all' ? 'active' : ''}`} onClick={() => this.setRank('all')}>All <span className="cnt">{rows.length}</span></button>
              {templates.map(t => (
                <button key={t._id} className={`gl-seg-btn ${this.state.rankType === t._id ? 'active' : ''}`} onClick={() => this.setRank(t._id)}>
                  {t.entityTemplateName}
                </button>
              ))}
            </div>
            <div className="gl-search">
              <i className="fas fa-magnifying-glass"></i>
              <input placeholder="Filter clients…" value={this.state.search} onChange={(e) => this.handleSearch(e.target.value)} />
            </div>
          </div>
        )}

        {/* Frosted list */}
        {!this.state.showAdd && (
          <div className="gl-list" style={{ ['--gl-cols']: CLIENT_COLS }}>
            <div className="gl-list-head">
              <div>Client</div>
              <div>Type</div>
              <div>Outstanding</div>
              <div></div>
            </div>

            {filtered.length === 0 && (
              <div className="gl-empty">No clients match this view.</div>
            )}

            {groupOrder.map(g => {
              const items = groups[g.key];
              if (!items || items.length === 0) return null;
              const gsum = items.reduce((s, it) => s + (it.outstanding || 0), 0);
              return (
                <React.Fragment key={g.key}>
                  <div className="gl-group-head">
                    <span className="lbl">{g.label}</span>
                    <span className="count">{items.length}</span>
                    <span className="sum">R {format(gsum)}</span>
                  </div>
                  {items.map(it => (
                    <div key={it.id} className={`gl-row ${g.cls}`} onClick={() => openEntity(it.id)}>
                      <div className="gl-client">
                        <div className={`gl-av gl-av-${avColor(it.name)}`}>{initials(it.name)}</div>
                        <div style={{ minWidth: 0 }}>
                          <div className="name">{it.name || '—'}</div>
                          {it.email ? <div className="sub">{it.email}</div> : null}
                        </div>
                      </div>
                      <div className="gl-num">{it.type || '—'}</div>
                      <div className={`gl-amount ${it.outstanding > 0 ? '' : 'paid'}`}>R {format(it.outstanding)}</div>
                      <div className="gl-actions" onClick={(e) => e.stopPropagation()}>
                        <button type="button" className="gl-icon-btn" onClick={() => openEntity(it.id)}>
                          <i className="fas fa-arrow-right"></i>
                        </button>
                      </div>
                    </div>
                  ))}
                </React.Fragment>
              );
            })}
          </div>
        )}
      </div>
    );
  }
}

export default EntityView;
